module.exports = __webpack_public_path__ + "static/high-performer-winter-2022-6b979353eca9d2f392806e9bbb11bb6f.svg";